<template>
    <div class="MyCollection">
        <!-- 空白页 -->
        <div class="blankWrap" v-if="showBlankPages">
            <img src="../../assets/img/blank.png" />
            <p>暂时没有收藏内容</p>
        </div>
        <!-- 有内容 -->
        <div class="haveCont" v-else>
            <div class="top_title">
                <h3>共收藏{{totalPage}}个视频</h3>
            </div>
            <!-- 列表 -->
            <ul class="listWrap">
                <li v-for="(item,index) in collectionList" :key="index">
                    <router-link :to="{path:'/playVideo', query:{courseId:item.CourseID,id:item.ID}}">
                        <div class="picBox">
                            <img :src="item.CourseImgPath" />
                            <p><span>{{item.Score}}</span><span>学分</span></p>
                        </div>
                        <div class="infoWrap">
                            <p class="category"><span>{{item.Keywords}}</span></p>
                            <h2>{{item.CourseTitle}}</h2>
                            <h4>{{item.Title}}</h4>
                            <div class="info">
                                <p>时长：<span>{{item.Duration}}</span></p>
                                <p>播放：<span>{{item.Hits}}</span></p>
                            </div>
                        </div>
                        <div class="head-zan">
                            <p class="head"><img src="../../assets/img/speaker.jpg" /><span>{{item.LectureName}}</span></p>
                        </div>
                    </router-link>
                    <div class="deleteBox" @click="deleteCollect(item.ID)">
                        <i class="el-icon-delete"></i>
                        <span>删除</span>
                    </div>
                </li>
            </ul>
            <!-- 分页器 -->
            <div class="page"><Pagination :total='totalPage' :page="page" :pageSize = 'pagesize' @currentPage="currentPage"></Pagination></div>
        </div>
        <!-- 移动端 -->
        <p class="moreCourse" v-if="isShowMore" @click="getMore">查看更多</p>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import common from '../../components/common.js'
export default {
    data() {
        return {
            showBlankPages:false,  // 空白页
            totalPage:0,  // 总页数
            page:1,  // 页数
            pagesize:9,  // 多少条数据
            collectionList:[],  // 列表
            isShowMore:true,  // 移动端的查看更多
        }
    },
    mounted(){
        // 获取收藏列表
        this.getList();
    },
    methods: {
        // 移出收藏
        deleteCollect(id){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":id,
                "Flag":0
            }
            this.$axios.post(Const_Api_Root+'api/Video/PutMark',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                if(res.data.Status == 0){
					common.$emit('markVideoNum',--this.totalPage);
                    this.getList();
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 分页器
        currentPage(index){
            this.page = index;
            this.getList();
        },
        // 获取列表
        getList(type){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "PageSize":this.pagesize,
                "CurPage":this.page
            }
            this.$axios.post(Const_Api_Root+'api/Member/MyLessonMark',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    // 总数
                    this.totalPage = res.data.Data.Total;
                    // 是否显示空白页
                    if(this.totalPage == 0){
                        this.showBlankPages = true;
						this.isShowMore = false;
                        return;
                    }
                    if(type == 'more'){
                        // 移动端的操作
                        this.collectionList = this.collectionList.concat(res.data.Data.Rows);
                    }else{
                        // 列表
                        this.collectionList = res.data.Data.Rows;
                    }

                    // 是否显示查看更多
                    if(this.totalPage != this.collectionList.length){
                        this.isShowMore = true;
                    }else{
                        this.isShowMore = false;
                    }
                    // 格式化关键词
                    for(let i=0;i<this.collectionList.length;i++){
                        let keyWord = this.collectionList[i].Keywords;
                        if(keyWord != undefined){
                            this.collectionList[i].Keywords = keyWord.toString();
                        }
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 移动端的获取更多
        getMore(){
            this.page++;
            this.getList('more');
        }
    },
    components: {
        Pagination
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .page{
        display: none;
    }
    .moreCourse{
        font-size: 14px;
        color: #0061FE;
        text-align: center;
        font-weight: bold;
        padding: 20px 0;
    }
	.blankWrap{
	    width: 100%;
	    margin: 0 auto 50px;
	    img{
	        width: 100%;
	        height: auto;
	    }
	    p{
	        font-size: 24px;
	        color: rgba(25,25,26,0.20);
	        margin-top: 22px;
	        text-align: center;
	    }
	}
    .listWrap{
        justify-content: center;
        li{
            width: 100%;
            margin: 30px 0;
            .deleteBox{
                display: block;
            }
        }
    }
    .top_title h3{
        font-size: 12px;
        font-weight: bold;
        margin-top: 30px;
    }
}
@media screen and (min-width: 1445px) {
    .MyCollection{
        width: 1200px;
        margin: 60px auto 132px;
        .listWrap li{
            margin: 30px 30px 30px 0;
            width: 31.5%;
            &:nth-child(3n){
                margin-right: 0;
            }
            &:hover .deleteBox{
                display: block;
            }
            .picBox img{
                height: 250px;
            }
        }
    }
	.blankWrap{
	    width: 407px;
	    margin: 192px auto 356px;
	    img{
	        width: 407px;
	        height: 253px;
	    }
	    p{
	        font-size: 24px;
	        color: rgba(25,25,26,0.20);
	        margin-top: 22px;
	        text-align: center;
	    }
	}
    .top_title h3{
        font-size: 20px;
    }
    .moreCourse{
        display: none;
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .MyCollection{
        width: 1100px;
        margin: 60px auto 132px;
        .listWrap li{
            margin: 30px 30px 30px 0;
            width: 31.5%;
            &:nth-child(3n){
                margin-right: 0;
            }
            &:hover .deleteBox{
                display: block;
            }
            .picBox img{
                height: 250px;
            }
        }
    }
	.blankWrap{
	    width: 407px;
	    margin: 192px auto 356px;
	    img{
	        width: 407px;
	        height: 253px;
	    }
	    p{
	        font-size: 24px;
	        color: rgba(25,25,26,0.20);
	        margin-top: 22px;
	        text-align: center;
	    }
	}
    .top_title h3{
        font-size: 20px;
    }
    .moreCourse{
        display: none;
    }
}
// 公用
.MyCollection{
    .haveCont{
        width: 100%;
    }
    .top_title{
        display: flex;
        align-items: center;
    }
}
.deleteBox{
    background: rgba(0,0,0,0.60);
    border-radius: 20px;
    width: 100px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    display: none;

    position: absolute;
    right: 20px;
    top: 20px;
}
.listWrap{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    li{
        position: relative;
        .picBox{
            width: 100%;
            height: auto;
            position: relative;
            img{
                width: 100%;
                height: 250px;
                border-radius: 16px;
            }
            p{
                background: #0061FE;
                border-radius: 16px 0 16px 0;
                color: #fff;
                width: 63px;
                height: 60px;

                position: absolute;
                right: 0;
                bottom: 0;
                span{
                    display: block;
                    text-align: center;
                }
                span:first-child{
                    font-size: 24px;
                    margin-top: 4px;
                }
                span:last-child{
                    font-size: 12px;
                }
            }
        }
    }
    .infoWrap{
        width: 100%;
        max-width: 100%;
        padding-left: 15px;
        h2{
            font-size: 20px;
            color: #19191A;
            font-weight: bold;
            overflow: hidden; 
            text-overflow: ellipsis;
            white-space: nowrap; 
        }
        h4{
            font-size: 15px;
            margin-top: 10px;
        }
        .info{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            display: flex;
            margin: 10px 0 20px;
            p{
                margin-right: 10px;
            }
        }
    }
    .head-zan{
        display: flex;
        align-items: center;
        padding-left: 15px;
        img{
            width: 24px;
            height: 24px;
        }
        .head{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            img{
                border-radius: 50%;
                margin-right: 10px;
                vertical-align: middle;
            }
        }
    }
    .category{
        font-size: 12px;
        color: #0061FE;
        margin: 30px 0 20px;
        span{
            margin-right: 10px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/PersonalCenter/MyCollection.vue